import {PeriodType} from '../components/EnhancementsReport/PeriodTypeSelector'

interface PayPeriodData {
  payPeriod?: string | null;
}

export const generatePayPeriodLabelsFromData = (data: PayPeriodData[]): string[] => {
  if (!data || data.length === 0) return []
  
  const uniqueLabels = data
    .map(item => item.payPeriod)
    .filter<string>((period): period is string => period !== null && period !== undefined && period.trim() !== '')
    .reduce((acc: string[], period) => {
      if (!acc.includes(period)) {
        acc.push(period)
      }
      return acc
    }, [])

  return uniqueLabels
}

export const getChartTitle = (periodType: PeriodType): string =>
  `Enhancement By Type By ${periodType}`
